// https://stimulus.hotwired.dev
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["content"]
  static classes = ["invisibility"]

  clicked(event) {
    if (this.hasContentTarget) {
      event.stopPropagation()
      this.contentTarget.classList.toggle(this.invisibilityClass)
    }
  }

  close(event) {
    if (this.hasContentTarget) {
      this.contentTarget.classList.add(this.invisibilityClass)
    }
  }
}
